import type { Course, Cuisine, RecipeVisibility } from '@fewerbags/schema';

export type RecipeSort = 'updated' | 'title' | 'rating';

/** The list screen's filter state — also the cache key, so it must stay serialisable. */
export interface RecipeFilters {
  q: string;
  tag: string;
  visibility: '' | RecipeVisibility;
  cuisine: '' | Cuisine;
  course: '' | Course;
  sort: RecipeSort;
}

export const DEFAULT_FILTERS: RecipeFilters = {
  q: '',
  tag: '',
  visibility: '',
  cuisine: '',
  course: '',
  sort: 'updated',
};

/** Recipes fetched per page in the infinite "Load more" list. */
export const RECIPE_PAGE_SIZE = 24;

/** Filters → the query object the API client validates (empty strings are dropped). */
export function toListQuery(f: RecipeFilters, page: { offset?: number; limit?: number } = {}) {
  return {
    ...(f.q.trim() === '' ? {} : { q: f.q.trim() }),
    ...(f.tag === '' ? {} : { tag: f.tag }),
    ...(f.visibility === '' ? {} : { visibility: f.visibility }),
    ...(f.cuisine === '' ? {} : { cuisine: f.cuisine }),
    ...(f.course === '' ? {} : { course: f.course }),
    sort: f.sort,
    limit: page.limit ?? RECIPE_PAGE_SIZE,
    offset: page.offset ?? 0,
  };
}

/** Query keys for the recipe and import screens, all under stable prefixes. */
export const recipeKeys = {
  all: ['recipes'] as const,
  list: (scope: 'own' | 'public', filters: RecipeFilters) =>
    ['recipes', 'list', scope, filters] as const,
  detail: (id: string) => ['recipes', 'detail', id] as const,
  tags: ['recipes', 'tags'] as const,
  publicTags: ['recipes', 'publicTags'] as const,
  rankings: (filters: { cuisine: string; course: string; sortBy: string }) =>
    ['recipes', 'rankings', filters] as const,
};

export const importKeys = {
  all: ['imports'] as const,
  list: ['imports', 'list'] as const,
  detail: (id: string) => ['imports', 'detail', id] as const,
};
